import { Result } from '../../Shared/Protocol/protocol-result'
import { HubDashboardApiRemoteService } from '../../Services/api/dashboard/hub-dashboard-service'
import {
  IHubDashboardChartItem,
  IHubDashboardOrderStatusGroup,
  ILoadHubDashboardChartResult,
} from '../../Services/api/dashboard/hub-dashboard.interface'

export class LoadHubDashboardUseCase {
  constructor(private readonly hubDashboardService: HubDashboardApiRemoteService) {}

  public async loadModuleTotal(endpoint: string): Promise<Result<number>> {
    return this.hubDashboardService.getListTotal(endpoint)
  }

  public async loadOrdersChart(
    groups: IHubDashboardOrderStatusGroup[],
  ): Promise<Result<ILoadHubDashboardChartResult>> {
    const aggregated = await this.hubDashboardService.getOrdersByStatusAggregated()

    if (!aggregated.isFailure) {
      const payload = aggregated.getValue()
      const apiGroups = payload?.groups

      if (apiGroups?.length) {
        const byLabel = new Map(
          apiGroups.map((group) => [
            (group.label ?? group.name ?? '').trim().toLowerCase(),
            group.count ?? 0,
          ]),
        )

        const data: IHubDashboardChartItem[] = groups.map((group) => ({
          name: group.name,
          value: byLabel.get(group.name.trim().toLowerCase()) ?? 0,
          fill: group.fill,
        }))

        return Result.ok({ data, failed: false, usedAggregatedEndpoint: true })
      }
    }

    let failed = false
    const data: IHubDashboardChartItem[] = []

    for (const group of groups) {
      const totalResult = await this.hubDashboardService.getOrdersTotalByStatus(group.statuses)

      if (totalResult.isFailure) {
        failed = true
        data.push({ name: group.name, value: 0, fill: group.fill })
        continue
      }

      data.push({
        name: group.name,
        value: totalResult.getValue() ?? 0,
        fill: group.fill,
      })
    }

    return Result.ok({ data, failed, usedAggregatedEndpoint: false })
  }
}
